import { CatalogViewSettingsContent } from "@ext/catalog/views/components/Sections/CatalogViewSettingsContent";
import { useCatalogViews, useCatalogViewsAccess } from "@ext/catalog/views/logic/hooks/useCatalogViews";
import { CATALOG_VIEW_PANEL_ID } from "@ext/catalog/views/models/consts";
import t from "@ext/localization/locale/translate";
import { FloatingPanel, usePanelToggle } from "@ui-kit/FloatingPanel";
import { ComponentVariantProvider } from "@ui-kit/Providers";

export const CatalogViewPanel = () => {
	const { isOpen } = usePanelToggle(CATALOG_VIEW_PANEL_ID);
	const { hasViews, canEditCatalogViews, canSeeCatalogViews } = useCatalogViewsAccess();
	const {
		items,
		isLoading,
		hasMoreRef,
		onLoadMore,
		createView,
		updateView,
		onUpdateDocportalVisible,
		onDeleteClick,
	} = useCatalogViews(isOpen);

	if (!canSeeCatalogViews) return null;

	return (
		<FloatingPanel icon="eye" id={CATALOG_VIEW_PANEL_ID} title={t("catalog.views.trigger")}>
			<ComponentVariantProvider variant="glass">
				<div className="flex min-h-0 flex-1 flex-col">
					<CatalogViewSettingsContent
						editable={canEditCatalogViews}
						hasMoreRef={hasMoreRef}
						hasViews={hasViews}
						isLoading={isLoading}
						items={items}
						onDeleteClick={onDeleteClick}
						onLoadMore={onLoadMore}
						onSaveClick={canEditCatalogViews ? createView : undefined}
						onUpdateClick={canEditCatalogViews ? updateView : undefined}
						onUpdateDocportalVisible={canEditCatalogViews ? onUpdateDocportalVisible : undefined}
					/>
				</div>
			</ComponentVariantProvider>
		</FloatingPanel>
	);
};
